<div
  class="fixed duration-500 transition-transform inset-x-0 bottom-0 z-50 flex flex-col items-center justify-center bg-gray-800 text-white p-4 sm:p-6 lg:p-8"
  [class.translate-y-full]="consentAsked()"
>
  <p class="md:text-lg text-center mb-4" i18n>
    We use cookies and other tracking technologies to analyze our website
    traffic.
  </p>
  <div class="flex flex-col md:flex-row gap-2">
    <button
      id="analytics-consent"
      data-cy="accept-tracking"
      (click)="acceptTracking()"
      class="bg-primary w-full min-w-[200px] hover:bg-primary-800 px-4 py-2 text-sm md:text-base font-semibold rounded-lg mb-2 md:mb-0"
      i18n
    >
      I Agree
    </button>
    <button
      (click)="denyTracking()"
      data-cy="deny-tracking"
      class="bg-gray-600 w-full min-w-[200px] hover:bg-gray-700 px-4 py-2 text-sm md:text-base font-semibold rounded-lg"
      i18n
    >
      I Decline
    </button>
  </div>
</div>
